export default __webpack_public_path__ + "static/16-12216c03c99585aa2157f0e5aadd5bda.jpg";